export default "__VITE_ASSET__414ba1cc__"